import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "원격 측정",
  "description": "Turborepo의 익명 원격 측정에 대해 자세히 알아보세요."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Vercel Inc. (Vercel)는 아래 설명된 대로 Turborepo 사용에 대한 원격 측정 데이터를 수집할 수 있습니다.\n원격 측정 데이터를 통해 사용 및 호스트 정보에 대한 익명 데이터를 수집하여 Turborepo 및 Vercel 플랫폼을 모니터링하고 개선할 수 있습니다. 이 데이터는 사용자에게 영향을 미치는 문제를 광범위하게 식별, 해결 또는 대응하는 데 사용될 수 있습니다."
  }, {
    "heading": "",
    "content": "원격 측정 데이터 수집은 선택 사항입니다. 원격 측정 데이터가 수집되는 것을 원하지 않으시면 opt-out할 수 있습니다."
  }, {
    "heading": "이유",
    "content": "원격 측정을 통해 모든 사용자에 걸쳐 Turborepo 기능 사용, 문제점 및 사용자 정의를 정확하게 측정할 수 있습니다.\n이 데이터를 통해 Turborepo를 대중에게 더 잘 맞춤화하여 지속적인 성장, 관련성 및 최고 수준의 개발자 경험을 보장할 수 있습니다.\n또한 이 데이터를 통해 개선 사항이 모든 애플리케이션의 기준을 개선하고 있는지 확인할 수 있습니다."
  }, {
    "heading": "수집되는-내용",
    "content": "일반적인 사용 정보를 추적하며, 구체적으로 무작위 식별자를 사용하여 익명화된 원격 측정 데이터로 다음을 추적합니다:"
  }, {
    "heading": "수집되는-내용",
    "content": "호출된 명령 (turbo run, turbo prune, turbo gen 등)"
  }, {
    "heading": "수집되는-내용",
    "content": "turbo의 버전"
  }, {
    "heading": "수집되는-내용",
    "content": "일반적인 머신 정보 (예: CPU 수, macOS/Windows/Linux, CI 내에서 명령이 실행되었는지 여부)"
  }, {
    "heading": "수집되는-내용",
    "content": "애플리케이션 크기 (전체 워크스페이스 수)"
  }, {
    "heading": "수집되는-내용",
    "content": "민감한 데이터를 포함할 수 있는 메트릭은 수집하지 않습니다. 여기에는 작업 이름, 패키지 이름, 민감한 인수 또는 플래그 값, 환경 변수, 파일 경로 또는 파일 내용이 포함되지만 이에 국한되지 않습니다."
  }, {
    "heading": "수집되는-내용",
    "content": "참고: 이 목록은 정확성을 보장하기 위해 정기적으로 감사됩니다."
  }, {
    "heading": "수집되는-내용",
    "content": "다음 환경 변수를 설정하여 정확히 무엇이 수집되는지 확인할 수 있습니다: TURBO_TELEMETRY_DEBUG=1."
  }, {
    "heading": "수집되는-내용",
    "content": "또한 events 파일을 직접 탐색하여 가능한 모든 이벤트를 볼 수 있습니다."
  }, {
    "heading": "비활성화",
    "content": "다음을 실행하여 opt-out할 수 있습니다:"
  }, {
    "heading": "비활성화",
    "content": "다음 환경 변수 중 하나를 설정하여 opt-out할 수도 있습니다:"
  }, {
    "heading": "비활성화",
    "content": "TURBO_TELEMETRY_DISABLED=1"
  }, {
    "heading": "비활성화",
    "content": "DO_NOT_TRACK=1 (Console Do Not Track (DNT)에 대해 자세히 알아보기)"
  }, {
    "heading": "상태",
    "content": "다음을 실행하여 언제든지 원격 측정 수집 상태를 확인할 수 있습니다:"
  }, {
    "heading": "활성화",
    "content": "프로그램에 다시 참여하고 싶다면 다음을 실행하여 원격 측정을 다시 활성화할 수 있습니다:"
  }],
  "headings": [{
    "id": "이유",
    "content": "이유"
  }, {
    "id": "수집되는-내용",
    "content": "수집되는 내용"
  }, {
    "id": "opt-out하는-방법",
    "content": "opt-out하는 방법"
  }, {
    "id": "비활성화",
    "content": "비활성화"
  }, {
    "id": "상태",
    "content": "상태"
  }, {
    "id": "활성화",
    "content": "활성화"
  }]
};
export const toc = [{
  depth: 2,
  url: "#이유",
  title: _jsx(_Fragment, {
    children: "이유"
  })
}, {
  depth: 2,
  url: "#수집되는-내용",
  title: _jsx(_Fragment, {
    children: "수집되는 내용"
  })
}, {
  depth: 2,
  url: "#opt-out하는-방법",
  title: _jsx(_Fragment, {
    children: "opt-out하는 방법"
  })
}, {
  depth: 3,
  url: "#비활성화",
  title: _jsx(_Fragment, {
    children: "비활성화"
  })
}, {
  depth: 3,
  url: "#상태",
  title: _jsx(_Fragment, {
    children: "상태"
  })
}, {
  depth: 3,
  url: "#활성화",
  title: _jsx(_Fragment, {
    children: "활성화"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Vercel Inc. (Vercel)는 아래 설명된 대로 Turborepo 사용에 대한 원격 측정 데이터를 수집할 수 있습니다.\n원격 측정 데이터를 통해 사용 및 호스트 정보에 대한 익명 데이터를 수집하여 Turborepo 및 Vercel 플랫폼을 모니터링하고 개선할 수 있습니다. 이 데이터는 사용자에게 영향을 미치는 문제를 광범위하게 식별, 해결 또는 대응하는 데 사용될 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["원격 측정 데이터 수집은 선택 사항입니다. 원격 측정 데이터가 수집되는 것을 원하지 않으시면 ", _jsx(_components.a, {
        href: "#how-do-i-opt-out",
        children: "opt-out"
      }), "할 수 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "이유",
      children: "이유"
    }), "\n", _jsx(_components.p, {
      children: "원격 측정을 통해 모든 사용자에 걸쳐 Turborepo 기능 사용, 문제점 및 사용자 정의를 정확하게 측정할 수 있습니다.\n이 데이터를 통해 Turborepo를 대중에게 더 잘 맞춤화하여 지속적인 성장, 관련성 및 최고 수준의 개발자 경험을 보장할 수 있습니다.\n또한 이 데이터를 통해 개선 사항이 모든 애플리케이션의 기준을 개선하고 있는지 확인할 수 있습니다."
    }), "\n", _jsx(_components.h2, {
      id: "수집되는-내용",
      children: "수집되는 내용"
    }), "\n", _jsx(_components.p, {
      children: "일반적인 사용 정보를 추적하며, 구체적으로 무작위 식별자를 사용하여 익명화된 원격 측정 데이터로 다음을 추적합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["호출된 명령 (", _jsx(_components.a, {
          href: "/docs/reference/run",
          children: "turbo run"
        }), ", ", _jsx(_components.a, {
          href: "/docs/reference/prune",
          children: "turbo prune"
        }), ", ", _jsx(_components.a, {
          href: "/docs/reference/generate",
          children: "turbo gen"
        }), " 등)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo"
        }), "의 버전"]
      }), "\n", _jsx(_components.li, {
        children: "일반적인 머신 정보 (예: CPU 수, macOS/Windows/Linux, CI 내에서 명령이 실행되었는지 여부)"
      }), "\n", _jsx(_components.li, {
        children: "애플리케이션 크기 (전체 워크스페이스 수)"
      }), "\n", _jsxs(_components.li, {
        children: ["민감한 데이터를 포함할 수 있는 메트릭은 ", _jsx(_components.strong, {
          children: "수집하지 않습니다"
        }), ". 여기에는 작업 이름, 패키지 이름, 민감한 인수 또는 플래그 값, 환경 변수, 파일 경로 또는 파일 내용이 포함되지만 이에 국한되지 않습니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "참고"
      }), ": 이 목록은 정확성을 보장하기 위해 정기적으로 감사됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["다음 환경 변수를 설정하여 정확히 무엇이 수집되는지 확인할 수 있습니다: ", _jsx(_components.code, {
        children: "TURBO_TELEMETRY_DEBUG=1"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["또한 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/blob/main/crates/turborepo-telemetry/src/events",
        children: "events"
      }), " 파일을 직접 탐색하여 가능한 모든 이벤트를 볼 수 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "opt-out하는-방법",
      children: "opt-out하는 방법"
    }), "\n", _jsx(_components.h3, {
      id: "비활성화",
      children: "비활성화"
    }), "\n", _jsx(_components.p, {
      children: "다음을 실행하여 opt-out할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " disable"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "다음 환경 변수 중 하나를 설정하여 opt-out할 수도 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "TURBO_TELEMETRY_DISABLED=1"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "DO_NOT_TRACK=1"
        }), " (", _jsx(_components.a, {
          href: "https://consoledonottrack.com/",
          children: "Console Do Not Track (DNT)"
        }), "에 대해 자세히 알아보기)"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "상태",
      children: "상태"
    }), "\n", _jsx(_components.p, {
      children: "다음을 실행하여 언제든지 원격 측정 수집 상태를 확인할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " status"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "활성화",
      children: "활성화"
    }), "\n", _jsx(_components.p, {
      children: "프로그램에 다시 참여하고 싶다면 다음을 실행하여 원격 측정을 다시 활성화할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " enable"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
